import { Component, OnInit } from '@angular/core';
import { Customer } from '../../../dto/customer';
import { toDateTimeString, toDateString } from '../../../providers/app-date-adapter';
import { Router, ActivatedRoute, RouterLinkWithHref } from '@angular/router';
import { CustomersService } from '../../services/customers.service';
import { Location } from '@angular/common';
import { Card } from '../../../dto/card';
import { CardsService } from '../../services/cards.service';
import { EventLog } from '../../../dto/event-log';
import { EventLogService } from '../../../services/crud/event-log.service';
import { ObjectComment } from '../../../dto/object-comment';
import { ObjectCommentsService } from '../../services/object-comment.service';
import { RoleService } from '../../../services/role.service';
import { OrdersService } from '../../services/orders.service';
import { IdentStatus } from '../../../dto/ident-status';
import { WebIdTransaction } from '../../../dto/web-id-transaction';
import { WebIdTransactionService } from '../../services/webid-transaction.service';
import { FileHelper } from '../../../helpers/file-helper';
import { CardReorderDialogComponent } from '../../../shared/card-reorder-dialog/card-reorder-dialog.component';
import { CardReorderModel } from '../../../models/card-reorder-model';
import {Order} from '../../../dto/order';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-customer-view',
  templateUrl: './customer-view.component.html',
  styleUrls: ['./customer-view.component.css']
})
export class CustomerViewComponent implements OnInit {

  customer: Customer;
  logs: EventLog[];
  customerId: number;
  comments: ObjectComment[];
  commentsTarget = 1;
  number = Number;

  fields = [
    { header: 'Title', cell: (row: Customer) => `${row.title}` },
    { header: 'First name', cell: (row: Customer) => `${row.firstName || ''}` },
    { header: 'Last name', cell: (row: Customer) => `${row.lastName || ''}` },
    { header: 'Address', cell: (row: Customer) => `${row.address || ''}` },
    { header: 'City', cell: (row: Customer) => `${row.city || ''}` },
    { header: 'Zip code', cell: (row: Customer) => `${row.zipCode || ''}` },
    { header: 'Email', cell: (row: Customer) => `${row.email || ''}` },
    { header: 'Phone', cell: (row: Customer) => `${row.phone || ''}` },
    { header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob) || ''}` },
    { header: 'Country', cell: (row: Customer) => `${row.countryName || ''}` },
    { header: 'IP Address', cell: (row: Customer) => `${row.ipAddress || ''}` },
    { header: 'Order language', cell: (row: Customer) => {
        switch (row.orderLanguage) {
          case 0: return 'german';
          case 1: return 'english';
          case 2: return 'norwegian';
          case 3: return 'spanish';
          case 4: return 'italian';
          case 5: return 'french';
          default: return '(unknown)';
        }
      } },
    { header: 'Subscribed to news', cell: (row: Customer) => `${row.subscribeToNews ? 'Yes' : 'No' || ''}` },
  ];

  ordersFields = [
    { header: 'Order ID', cell: ( row: number ) => `${ this.customer.orders[row].id || ''}` },
    { header: 'WebID transaction', cell: ( row: number ) => `${ (this.customer.orders[row].webIdTransaction || ({} as WebIdTransaction)).id  || 'WebID Was not required' }`  },
    { header: 'WebID status', cell: ( row: number ) => `${ IdentStatus[(this.customer.orders[row].webIdTransaction || ({} as WebIdTransaction)).status] || 'WebID Was not required' }` },
    { header: 'Response File', cell: ( row: number ) => `${ (this.customer.orders[row].webIdTransaction || ({} as WebIdTransaction)).responseFileId || 'No File Yet' }`, type: 'button' },
  ];

  cardFields = [
    { header: 'Card Token'        , cell: (row: Card) => `${row.token}` },
    { header: 'Creation date'     , cell: (row: Card) => `${toDateTimeString(row.creationDate) || ''}` },
    { header: 'Activation date'   , cell: (row: Card) => `${toDateTimeString(row.activationDate) || ''}` },
    { header: 'Order date'        , cell: (row: Card) => `${toDateString(row.orderDate) || ''}` },
    { header: 'Next Annual Fee', cell: (row: Card) => `${toDateString(row.nextAnnualFeeDateDisplayed || row.nextAnnualFeeDate) || ''}` } as ContentRowField<Card>,
    { header: 'Order'             , cell: (row: Card) => '<i orders/'  + (row.orderId || '')        + ' | ' + `${row.orderId      || ''}` },
    { header: 'SEPA Count'        , cell: (row: Card) => '<a sepas '   + row.token                  + ' '   + `${row.sepas.length || 0 }` }, // <a route_to_page search_string information_to_display
    { header: 'SOFORT Count'      , cell: (row: Card) => '<a soforts ' + row.token                  + ' '   + `${row.soforts.length || 0 }` },
    { header: 'PAN'      , cell: (row: Card) => `${row.maskedPAN || '(unknown)' }` },
    { header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`},
    { header: 'Invoice'           , cell: (row: Card) => '<a invoices/' + (row.order.invoiceId || '') + ' | ' + `${row.order.invoiceNumber || ''}`},
    { header: 'Payment Reminders' , cell: (row: Card) => `${ row.order.paymentEmailReminders && row.order.paymentEmailReminders.length || 0 }` },

    // { header: "Payment Reminders" , cell: (row: Card) => "<a payment-reminders" + row.token + " " + `${ row.order.paymentEmailReminders.length || 0 }` },
    // DO NOT DELETE
    // { header: "Rec ID", cell: (row: Card) => `${row.recId || ""}` },
    // { header: "Status", cell: (row: Card) => `${row.statusName || ""}` },
    // { header: "Comment", cell: (row: Card) => `${row.comment || ""}` },
    // { header: "Pull date", cell: ( row: Card ) => `${ toDateTimeString( row.pullDate ) || "" }` },
  ];




  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private cardsService: CardsService,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private logService: EventLogService,
    private objectCommentsService: ObjectCommentsService,
    private ordersService: OrdersService,
    private transactionService: WebIdTransactionService,
    private dialog: MatDialog,
    private _toastService: ToastService,
  ) { }

  ngOnInit() {
    this.customerId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.refreshCustomer();

    this.logService.get( 15, this.customerId ).subscribe( data => {
      this.logs = data;
    });
    this.objectCommentsService.getForObject( this.customerId, this.commentsTarget ).subscribe( data => {
      this.comments = data;
    });

  }


  closeCard( id: number ) {

    this.showError('This function is disabled. Use customer overview to close card');
    return;

    // this would have needed to be refactored to the closeCard function with a reason
    // which was not necessary at the time being

    /*this.cardsService.closeCards( [ id ] )
      .subscribe( result => {
        this.showMessage( "The card is closed");
        this.refreshCards();

      } );*/
  }

  showMessage(msg) {
    this.snackBar.open( msg, null, {
      duration: 5000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }

  showError(msg) {
    this._toastService.error(msg);
  }

  returnBack() {
    this.location.back();
  }

  refreshCustomer() {
    this.customersService.get( this.customerId ).subscribe( data => {
      this.customer = data;
    } );
  }

  refreshCards() {
    this.cardsService.getForCustomer( this.customerId ).subscribe( data => {
      this.customer.cards = data;
    } );
  }

  editEnabled() {
    return this.roleService.hasRoles( [ 'admin' ] );
  }


  showLogs() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  showCardActions() {
    return this.roleService.hasRoles(['admin']);
  }

  reorderCard(id: number) {

    this.showError('This function is disabled. Use customer overview to re-order card');
    return;

    // we will lead users to the customer overview instead of double-coding this

    /*this.dialog.open(CardReorderDialogComponent).afterClosed()
    .subscribe(dlgResult => {
      if (dlgResult instanceof CardReorderModel) {
        dlgResult.id = id;
        this.ordersService.reorderCard(dlgResult).subscribe(result => {

          if ( result.isError ) {
            this._toastService.error("Error re-ordering: " + result.errorMessage);
          } else if ( result.needsConfirmation) {
            this._toastService.warn("Re-Order of this card needs confirmation by compliance");
            this.refreshCustomer();
          }
          else {
            this._toastService.success("Card has been reordered");
            this.refreshCustomer();
          }
        });
      }
    });*/
  }

  downloadAttachment(transactionId: string) {
    this.transactionService.getAttachment( parseInt( transactionId ) ).subscribe(
        result => {
          FileHelper.saveFile( result );
        },
        err =>
          this.snackBar.open( err.error.message || err.message || err.error || err, null, {
              duration: 5000,
              panelClass: [ 'app-mat-snack-bar' ]
            } )
      );
  }

  IsNaN(number: any) {
    return isNaN(parseInt(number));
  }
}
